import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { EpicDependencies } from "../rxjs/configureEpics"
import type { AggregateType, Operation, OperationsBatch } from "./types"
import { getUtcTimestamp } from "../../utils/dateFunctions"

export const createOperation = (
    deps: EpicDependencies,
    type: string,
    recordType: string,
    recordId: string,
    recordVersion: number,
    params: Maybe<Record<string, any>>,
    aggregateType?: Maybe<AggregateType>,
    aggregateId?: Maybe<string>
): Operation => ({
    id: deps.idgen.next(),
    type: type,
    record_type: recordType,
    record_id: recordId,
    record_version: recordVersion,
    params: params,
    aggregate_id: aggregateId,
    aggregate_type: aggregateType,
    // @ts-expect-error
    origin_timestamp: getUtcTimestamp(),
})

export const createArrayOfOperationsToSend = (operations: Operation[], deps: EpicDependencies): OperationsBatch => {
    return {
        id: deps.idgen.next(),
        operations: operations,
    }
}

export const addAuditToOperation = (operation: Operation, userId: Maybe<string>): Operation => ({
    ...operation,
    ...(userId
        ? {
              user_id: userId,
          }
        : null),
})
